import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import VatRateHistoryForm from '../../../components/forms/VatRateHistoryForm';
import { useVatRateHistoryById, useUpdateVatRateHistory } from '../../../hooks/useVatRateHistoryApi';
import { useNavigate, useParams } from 'react-router-dom';

const VatRateHistoryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useVatRateHistoryById(id!);
  const updateMutation = useUpdateVatRateHistory();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'VAT Rates', href: '/admin/vatratehistories' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/vatratehistories');
    } catch (error) {
      console.error('Error updating VatRateHistory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/vatratehistories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.VatRateHistory.Edit"
    >
      {entityData ? (
        <VatRateHistoryForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/vatratehistories')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default VatRateHistoryEdit;
